import { Popup } from '@shared/layouts/popup/popup'
import { useTranslation } from 'react-i18next'

import { Button } from '@components/button/button'
import { CloseBtn } from '@components/close-btn/close-btn'

import { ConfirmModalParams } from '../../types'

import styles from './confirmation.module.css'

export const Confirmation = ({
  confirmText,
  description,
  onClose,
  onConfirm
}: ConfirmModalParams) => {
  const { t } = useTranslation('main')
  return (
    <Popup isOpened={true} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.header}>
          <CloseBtn size="sm" className={styles.btnClose} onClose={onClose} />
        </div>
        <div className={styles.body}>
          <span className={styles.text}>
            {description} {confirmText} ?
          </span>
        </div>
        <div className={styles.footer}>
          <Button className={styles.btn} flat onClick={onConfirm}>
            {t('remove')}
          </Button>
          <Button
            className={styles.btn}
            flat
            appearance="inactive"
            onClick={onClose}
          >
            {t('cancel-remove')}
          </Button>
        </div>
      </div>
    </Popup>
  )
}
